import {Injectable} from '@angular/core';
import { NbMenuItem } from '@nebular/theme';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/**
 * Handles headertitleservice for this module.
 */
export class HeaderTitleService {
  protected menuItem: BehaviorSubject<NbMenuItem> = new BehaviorSubject({
    title: '',
  });

  constructor() {}

  /**
   * Handles publishheader for this module.
   */
  publishHeader(menuItem: NbMenuItem): void {
    this.menuItem.next(menuItem);
  }

  /**
   * Handles onheaderchange for this module.
   */
  onHeaderChange(): Observable<NbMenuItem> {
    return this.menuItem;
  }
}


